module.exports = __webpack_public_path__ + "static/img/banner_5.1b58c43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_5.jpg
// module id = TlJm
// module chunks = 0